import React, { useState, useEffect } from 'react';
import { AddButton, DeleteButton } from '../../Res/BaseButton';
import { uuid } from '../../../../item/ItemTools';
import { SingleInput, SingleText } from '../../Res/BaseInput';


export function ItemPayHourlyWage({ title, items, action, isEdit = false }) {
  const [mItems, setItems] = useState([])

  useEffect(() => {
    if (items !== undefined && items.length !== 0 && items !== mItems) {
      // console.log(items)
      setItems(items)
    }
  }, [items])

  useEffect(() => {
    if (mItems !== [] && mItems !== items) {
      action(mItems)
    }
  }, [mItems])

  function addItem() {
    var tItems = mItems.filter(item => {
      return item.text !== ""
    })
    var payHourlyWageId = uuid(32, 64)
    tItems.push({ id: payHourlyWageId, text: "" })
    setItems(tItems)
  }

  function delItem(id) {
    var tItems = mItems.filter(item => {
      return item.id !== id
    })
    setItems(tItems)
  }

  function setItemText(id, text) {
    var [...tItems] = mItems
    for (let v of tItems) if (v.id === id) v.text = text;
    setItems(tItems)
  }

  function getItemBox(item, index) {
    var html =
      <tr key={index}>
        <td className="text-center" style={{ verticalAlign: "middle" }}>{index + 1}</td>
        <td>
          {isEdit ?
            <SingleInput val={item.text} action={setItemText} id={item.id} size={12} />
            : <SingleText val={item.text} size={12} />
          }
        </td>

        {isEdit ?
          <td className="text-center"><DeleteButton action={delItem} id={item.id} /></td>
          : <></>
        }
      </tr>
    return html
  }

  return (
    <>
      <div className="panel panel-default">
        <div className="panel-heading">
          <div className="row">
            <div className="col-sm-4">
              <h3>{title}</h3>
            </div>
            <div className="col-sm-8">
              <div className="row text-right">
                {isEdit ?
                  <AddButton action={addItem} />
                  : <></>
                }
              </div>
            </div>
          </div>
        </div>
        <div className="panel-body">
          <div className="row">
            <div className="col-lg-12">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th className="text-center" style={{ width: "80px" }}>項次</th>
                    <th className="text-center" style={{ width: "300px" }}>項目名稱</th>
                    {isEdit ?
                      <th className="text-center" >功能</th>
                      : <></>
                    }
                  </tr>
                </thead>
                <tbody>
                  {mItems.map((item, index) => (
                    getItemBox(item, index)
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}